module.exports = __webpack_public_path__ + "static/media/google-button.b68ea30c.svg";